/* istanbul ignore file */
const STRINGS = {
  placeholder: "Enter or select options",
  instructToClear: "Clear to browse all options.",
  instructToEnter: "Enter text to find matches.",
  noMatchFound: "No matches for your entry.",
  noMatchesButNewEntry: "No matches found. A new entry will be created.",
  noMatchesAndNoNewEntry: "No matches found. Clear your entry and try again.",
  onlyOptionAvailable: option => `${option} is the only available option.`,
  manyOptionsAvailable: optionsNumber => `There are ${optionsNumber} options available.`,
  clearButtonAriaLabel: label => `Clear ${label}`
};
export default STRINGS;